export default __webpack_public_path__ + "static/media/4.0a0b588f.png";